import { useState, useContext, useEffect } from "react";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { githubContents1, githubContents } from "../APIs/githubApi";
import RepoContext from "../context/Repos";
import buildTree from "../utils/buildFolderTree";
import Spinner from "react-bootstrap/Spinner";

const GithubCredsForm = () => {
  const [show, setShow] = useState(false);
  const [isLoading,setIsLoading]=useState(false);

  const {
    InputRepo,
    OutputRepo,
    setInputRepo,
    setOutputRepo,
    setInputRepoCreds,
    setOutputRepoCreds,
    setSrcFileTree,
    setDestFileTree,
    initialSelection, 
    setInitialSelection,
  } = useContext(RepoContext);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  //while production change the values to blank;
  const [form1Data, setForm1Data] = useState({
    username: "Shashank1816",
    patToken: "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",
    repoName: "capitalization_backend",
  });

  const [form2Data, setForm2Data] = useState({
    username: "Shashank1816",
    patToken: "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",
    repoName: "code_migration_destination",
  });

  const handleForm1Change = (e) => {
    const { name, value } = e.target;
    setForm1Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleForm2Change = (e) => {
    const { name, value } = e.target;
    setForm2Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Perform form submission or any other required action
    if (
      form1Data.username === "" ||
      form1Data.patToken === "" ||
      form1Data.repoName === "" ||
      form2Data.username === "" ||
      form2Data.patToken === "" ||
      form2Data.repoName === ""
    ) {
      alert("Please fill all the fields");
      return;
    }

    setIsLoading(true); // Show loader

    //set Inputrepocreds and outputrepocreds to form1data and form2data
    setInputRepoCreds(form1Data);
    setOutputRepoCreds(form2Data);

    let sourceProject = await githubContents(
      form1Data.username,
      form1Data.patToken,
      form1Data.repoName
    );
    let destinationProject = await githubContents(
      form2Data.username,
      form2Data.patToken,
      form2Data.repoName
    );

    setInputRepo(sourceProject.data);
    setOutputRepo(destinationProject.data);

    const srcTree = await buildTree(
      sourceProject.data,
      form1Data.patToken,
      "input"
    );
    const destTree = await buildTree(
      destinationProject.data,
      form2Data.patToken,
      "output"
    );

    setSrcFileTree([...srcTree]);
    setDestFileTree([...destTree]);

    setIsLoading(false); // Hide loader
    handleClose();
  };

  return (
    <>
      <Button
        variant="secondary"
        style={{
          display: "flex",
          justifyContent: "align-item",
          float: "right",
          marginRight: "0.8vw",
          position: "relative",
          ...(InputRepo && OutputRepo 
            ?{
              bottom : "13vh",
            } :{
              bottom : "6.5vh"
            }
            )
          
        }}
        onClick={handleShow}
      >
        <OverlayTrigger
          placement="left"
          overlay={
            <Tooltip id="tooltip">
              Add the Github crentials for source and destination repo
            </Tooltip>
          }
        >
          <span style={{ justifyContent: "align-item", display: "flex" }}>
            <FiSettings />
          </span>
        </OverlayTrigger>
      </Button>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Fill in the Github Creds</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <h5>Source Repo Details</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="form1Username">
                  <Form.Label>Github Username</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={form1Data.username}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <Form.Group controlId="form1PatToken">
                  <Form.Label>PAT Token</Form.Label>
                  <Form.Control
                    type="text"
                    name="patToken"
                    placeholder="Enter PAT token"
                    value={form1Data.patToken}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <Form.Group controlId="form1RepoName">
                  <Form.Label>Repository Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="repoName"
                    placeholder="Enter repository name"
                    value={form1Data.repoName}
                    onChange={handleForm1Change}
                  />
                </Form.Group>
                <hr></hr>
                {/* Add additional form fields for the first form here */}
                {/* <Button variant="primary" type="submit">
                  Submit
                </Button> */}
              </Form>
            </Col>
            <Col>
              <h5>Destination Repo</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="form2Username">
                  <Form.Label>Github Username (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Enter username"
                    value={form2Data.username}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                <Form.Group controlId="form2PatToken">
                  <Form.Label>PAT Token (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="patToken"
                    placeholder="Enter PAT token"
                    value={form2Data.patToken}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                <Form.Group controlId="form2RepoName">
                  <Form.Label>Repository Name (Destination)</Form.Label>
                  <Form.Control
                    type="text"
                    name="repoName"
                    placeholder="Enter repository name"
                    value={form2Data.repoName}
                    onChange={handleForm2Change}
                  />
                </Form.Group>
                {/* Add additional form fields for the second form here */}
                <hr></hr>
                <Button variant="primary" type="submit">
                  {isLoading? <Spinner animation="border" role="status"></Spinner>: "Submit"}
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GithubCredsForm;
